export default "__VITE_ASSET__a45c1fa1__"